<button
    class="btn btn-{{ variant }} {{ sizeClass }} {{ klass }}"
    [class.btn-block]="full"
    [type]="type"
    (click)="(onClick)"
    [disabled]="disabled"
>
    <i *ngIf="iconLeft" class="btn-icon-left fa fa-{{ iconLeft }}"></i>
    {{ title ? title : '' }}
    <ng-content *ngIf="!title"></ng-content>
    <i *ngIf="iconRight" class="btn-icon-right fa fa-{{ iconRight }}"></i>
</button>
